var map = {
	"./en/b-icon-1-active.png": "25qi",
	"./en/b-icon-2-active.png": "ufOZ",
	"./en/b-icon-3-active.png": "UmxV",
	"./en/b-icon-4-active.png": "v23t",
	"./en/b-icon-5-active.png": "NKXR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jQMP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3 ^\.\/.*\-active\.png$
// module id = jQMP
// module chunks = 0